(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["free-shipping-message"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ghost-shipping-message')) {
    customElements.define('ghost-shipping-message', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const refreshAfterUpdate = async (event) => {
          try {
            if (event.promise) await event.promise;
            if (this.isConnected) this.refresh();
          } catch { /* A failed cart mutation leaves the existing message intact. */ }
        };
        
        const names = new Set([
          'cart:update',
          'cart:updated',
          'cart:change'
        ]);

        import('@shopify/events').then(({ StandardEvents }) => {
          const eventName = StandardEvents.cartLinesUpdate;

          if (!options.signal.aborted && eventName && !names.has(eventName)) {
            document.addEventListener(eventName, refreshAfterUpdate, options);
          }
        }).catch(() => {});



        names.forEach(name => { if (name) document.addEventListener(name, refreshAfterUpdate, options); });
        window.addEventListener('pageshow', () => this.refresh(), options);
        this.refresh();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.request?.abort();
      }
      async refresh() {
        this.request?.abort();
        this.request = new AbortController();
        try {
          const response = await fetch(this.dataset.cartUrl, {
            credentials: 'same-origin', cache: 'no-store', signal: this.request.signal,
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) return;
          const cart = await response.json();
          if (!this.isConnected || !Number.isFinite(cart.total_price)) return;
          const remaining = Math.max(0, Number(this.dataset.threshold) - cart.total_price);
          const amount = new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style: 'currency', currency: cart.currency || this.dataset.currency
          }).format(remaining / 100);
          const message = remaining === 0 ? this.dataset.successMessage : this.dataset.remainingMessage.split('[amount]').join(amount);
          const output = this.querySelector('[data-shipping-message]');
          if (output && output.textContent !== message) output.textContent = message;
        } catch { /* Keep the server-rendered message on network failure. */ }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ghost-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ghost-content-tabs')) {
  let instance = 0;
  customElements.define('ghost-content-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.instanceId ||= ++instance;
      const options = { signal: this.controller.signal };
      this.media = window.matchMedia('(max-width: 749px)');
      this.media.addEventListener('change', () => this.renderMode(true), options);

      this.addEventListener('click', (event) => {
        const button = event.target.closest('.ghost-tabs__tab, .ghost-tabs__accordion-button');
        if (!button || button.closest('ghost-content-tabs') !== this) return;
        if (button.classList.contains('ghost-tabs__accordion-button')) {
          const index = this.accordionButtons.indexOf(button);
          if (index < 0) return;
          const id = this.panels[index].id;
          this.mobileOpenId = this.mobileOpenId === id ? null : id;
          this.activeId = id;
          this.renderMode();
        } else {
          this.activate(this.buttons.indexOf(button));
        }
      }, options);

      this.addEventListener('keydown', (event) => {
        const button = event.target.closest('.ghost-tabs__tab');
        if (!button || button.closest('ghost-content-tabs') !== this || this.media.matches) return;
        const index = this.buttons.indexOf(button);
        const rtl = getComputedStyle(this).direction === 'rtl';
        let next;
        if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.buttons.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.activate((next + this.buttons.length) % this.buttons.length, true);
      }, options);

      document.addEventListener('shopify:block:select', (event) => {
        const index = this.panels?.findIndex((panel) =>
          panel === event.target || panel.contains(event.target) ||
          panel.dataset.blockId === event.detail?.blockId
        );
        if (index >= 0) this.activate(index);
      }, options);

      this.observer?.disconnect();
      this.observer = new MutationObserver(() => this.scheduleBuild());
      this.observer.observe(this, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['data-heading']
      });
      this.scheduleBuild();
    }

    scheduleBuild() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.build());
    }

    build() {
      if (!this.isConnected) return;
      const list = this.querySelector(':scope > .ghost-tabs__navigation > .ghost-tabs__list');
      const container = this.querySelector(':scope > .ghost-tabs__panels');
      if (!list || !container) return;
      const panels = Array.from(container.children).filter(panel => panel.classList.contains('ghost-tabs__panel'));
      panels.forEach((panel, index) => {
        if (!panel.id) panel.id = `ghost-tabs-${this.instanceId}-panel-${index + 1}`;
      });
      const signature = JSON.stringify(panels.map(panel => [panel.id, panel.dataset.heading]));
      if (signature === this.signature && panels.length === this.panels?.length &&
          panels.every((panel, index) => panel === this.panels[index]) &&
          this.buttons?.every(button => button.parentNode === list) &&
          this.accordionButtons?.every((button, index) =>
            button.parentNode?.parentNode === container &&
            button.parentNode.nextElementSibling === panels[index])) {
        this.renderMode();
        return;
      }
      this.signature = signature;
      this.panels = panels;
      this.navigation = list.parentElement;
      container.querySelectorAll(':scope > .ghost-tabs__accordion-heading').forEach(heading => heading.remove());
      this.accordionButtons = [];
      this.buttons = panels.map((panel, index) => {
        const label = panel.dataset.heading || 'Tab ' + (index + 1);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ghost-tabs__tab';
        button.id = panel.id + '-tab';
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', panel.id);
        button.textContent = label;

        const heading = document.createElement('h3');
        heading.className = 'ghost-tabs__accordion-heading';
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'ghost-tabs__accordion-button';
        toggle.id = panel.id + '-accordion';
        toggle.setAttribute('aria-controls', panel.id);
        const title = document.createElement('span');
        title.textContent = label;
        const icon = document.createElement('span');
        icon.className = 'ghost-tabs__accordion-icon';
        icon.setAttribute('aria-hidden', 'true');
        toggle.append(title, icon);
        heading.append(toggle);
        container.insertBefore(heading, panel);
        this.accordionButtons.push(toggle);
        return button;
      });
      list.replaceChildren(...this.buttons);
      const preferred = Math.max(0, (Number(this.dataset.defaultTab) || 1) - 1);
      const defaultPanel = panels[Math.min(preferred, panels.length - 1)];
      if (!panels.some(panel => panel.id === this.activeId)) this.activeId = defaultPanel?.id;
      if (this.mobileOpenId === undefined) this.mobileOpenId = this.activeId || null;
      if (this.mobileOpenId && !panels.some(panel => panel.id === this.mobileOpenId)) {
        this.mobileOpenId = this.activeId || null;
      }
      this.setAttribute('data-ready', '');
      this.renderMode();
    }

    renderMode(restoreFocus = false) {
      if (!this.panels || !this.navigation) return;
      const mobile = this.media.matches;
      const focused = document.activeElement;
      const focusedTab = this.buttons.indexOf(focused);
      const focusedAccordion = this.accordionButtons.indexOf(focused);
      const focusedPanel = this.panels.findIndex(panel => panel.contains(focused));
      if (restoreFocus && !mobile && focusedAccordion >= 0) {
        this.activeId = this.panels[focusedAccordion].id;
      } else if (restoreFocus && !mobile && focusedPanel >= 0) {
        this.activeId = this.panels[focusedPanel].id;
      }
      this.navigation.hidden = mobile || !this.panels.length;
      this.panels.forEach((panel, index) => {
        const selected = panel.id === this.activeId;
        const expanded = panel.id === this.mobileOpenId;
        panel.hidden = mobile ? !expanded : !selected;
        panel.setAttribute('role', mobile ? 'region' : 'tabpanel');
        panel.setAttribute('aria-labelledby', mobile ? this.accordionButtons[index].id : this.buttons[index].id);
        panel.tabIndex = mobile ? -1 : 0;
        this.buttons[index].setAttribute('aria-selected', String(selected));
        this.buttons[index].tabIndex = selected ? 0 : -1;
        this.accordionButtons[index].setAttribute('aria-expanded', String(expanded));
        this.accordionButtons[index].parentElement.hidden = !mobile;
        if (panel.hidden) panel.querySelectorAll('video').forEach(video => { if (!video.paused) video.pause(); });
      });
      if (restoreFocus) {
        if (mobile && focusedTab >= 0) this.accordionButtons[focusedTab].focus({ preventScroll: true });
        else if (!mobile && focusedAccordion >= 0) this.buttons[focusedAccordion].focus({ preventScroll: true });
        else if (mobile && focusedPanel >= 0 && this.panels[focusedPanel].hidden) {
          this.accordionButtons[focusedPanel].focus({ preventScroll: true });
        }
      }
    }

    activate(index, focus = false) {
      if (!this.panels?.[index]) return;
      this.activeId = this.panels[index].id;
      if (this.media.matches) this.mobileOpenId = this.activeId;
      this.renderMode();
      if (focus) {
        const button = this.media.matches ? this.accordionButtons[index] : this.buttons[index];
        button.focus({ preventScroll: true });
        button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
